import { useGlobalSearchParams } from 'expo-router'

import type { TCommunityJoinParams } from '@/src/general/constants/routes'
import { TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'

import { EVENT_ORIGIN } from '../../models/community.constants'

export const useCommunityJoinSearchParams = () => {
  const {
    idSlug,
    source = TRACKING_SOURCE.UNDEFINED,
    origin = EVENT_ORIGIN.UNDEFINED,
    course = 'undefined',
  } = useGlobalSearchParams<TIdSlugParam & TCommunityJoinParams>()

  return { idSlug, source, origin, course }
}
